export default __webpack_public_path__ + "static/media/logo-fr.b281fae0.png";